module.exports = __webpack_public_path__ + "static/media/Kaiser.65a9f717.webp";